module.exports = __webpack_public_path__ + "img/invoice-crypto-icon.1b36f926.svg";